/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker } from 'components/filters';
import {
  CustomerSubUnitSelect,
  OrderFullfillmentCenterSelect,
  OrderSelect,
  SupplierCustomerSelect,
} from 'components/Selects';
import {
  LabelInput,
  SecureFormsy,
  Select,
} from 'flaivy-react/components/inputs';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
/* eslint-enable */
import { resolve as customerSubUnitResolve } from '../../shared/actions/generated/customer-sub-unit.actions';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  if (query.customerSubUnit) {
    resolvedQuery.customerSubUnit = await customerSubUnitResolve(
      query.customerSubUnit,
    );
  }
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function OrderFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.orderFullfillmentCenter === 'undefined' && (
          <FormGroup>
            <Label>Leveranslager</Label>
            <OrderFullfillmentCenterSelect
              defaultOptions={false}
              instanceId="select-orderFullfillmentCenter"
              name="orderFullfillmentCenter"
              value={_.get(resolvedQuery, 'orderFullfillmentCenter')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.qvantiOrderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierOrderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.orderState === 'undefined' && (
          <FormGroup>
            <Label>Status</Label>
            <Select
              instanceId="select-orderState"
              name="orderState"
              value={_.get(resolvedQuery, 'orderState', '')}
              onChange={handleChange}
              options={[
                { value: 'draft', label: 'Utkast' || 'draft' },
                { value: 'created', label: 'Skapad' || 'created' },
                { value: 'received', label: 'Granskas' || 'received' },
                {
                  value: 'waitingForRestock',
                  label: 'Väntar på inleverans' || 'waitingForRestock',
                },
                {
                  value: 'waitingForAdvancePayment',
                  label:
                    'Väntar på administrativ hantering' ||
                    'waitingForAdvancePayment',
                },
                {
                  value: 'approved',
                  label: 'Skickad till lager' || 'approved',
                },
                {
                  value: 'approvedByDropshipSupplier',
                  label:
                    'Leverantören har godkänt order' ||
                    'approvedByDropshipSupplier',
                },
                {
                  value: 'inWarehouseProcess',
                  label: 'Hanteras av lager' || 'inWarehouseProcess',
                },
                {
                  value: 'readyForShipping',
                  label: 'Plockad' || 'readyForShipping',
                },
                { value: 'enRoute', label: 'På väg' || 'enRoute' },
                { value: 'delivered', label: 'Levererad' || 'delivered' },
                { value: 'returned', label: 'Retur till lager' || 'returned' },
                { value: 'invoiced', label: 'Fakturerad' || 'invoiced' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderOrigin === 'undefined' && (
          <FormGroup>
            <Label>Orderursprung</Label>
            <Select
              instanceId="select-orderOrigin"
              name="orderOrigin"
              value={_.get(resolvedQuery, 'orderOrigin', '')}
              onChange={handleChange}
              options={[
                { value: 'supplier', label: 'Manuell order' || 'supplier' },
                { value: 'export', label: 'EMCS-order' || 'export' },
                { value: 'customer', label: 'Flaivy.com' || 'customer' },
                {
                  value: 'systembolaget',
                  label: 'Systembolaget' || 'systembolaget',
                },
                { value: 'internal', label: 'Intern order' || 'internal' },
                { value: 'whitelabel', label: 'E-handel' || 'whitelabel' },
                { value: 'purchasing', label: 'Qvanti' || 'purchasing' },
                { value: 'stockfiller', label: 'Stockfiller' || 'stockfiller' },
                {
                  value: 'dropshipping',
                  label: 'Mail-flöde' || 'dropshipping',
                },
                {
                  value: 'returnToSupplier',
                  label: 'Utleverans' || 'returnToSupplier',
                },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.requiresEMCS === 'undefined' && (
          <FormGroup>
            <Label>Kräver ordern EMCS?</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'requiresEMCS') === undefined}
                onClick={() => {
                  handleChange('requiresEMCS', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresEMCS') === true ||
                  _.get(resolvedQuery, 'requiresEMCS') === 'true'
                }
                onClick={() => {
                  handleChange('requiresEMCS', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresEMCS') === false ||
                  _.get(resolvedQuery, 'requiresEMCS') === 'false'
                }
                onClick={() => {
                  handleChange('requiresEMCS', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.mergedOrderReference === 'undefined' && (
          <FormGroup>
            <Label>Sammanslagen med</Label>
            <OrderSelect
              defaultOptions={false}
              instanceId="select-mergedOrderReference"
              name="mergedOrderReference"
              value={_.get(resolvedQuery, 'mergedOrderReference')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.cancelled === 'undefined' && (
          <FormGroup>
            <Label>Makulerad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'cancelled') === undefined}
                onClick={() => {
                  handleChange('cancelled', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === true ||
                  _.get(resolvedQuery, 'cancelled') === 'true'
                }
                onClick={() => {
                  handleChange('cancelled', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === false ||
                  _.get(resolvedQuery, 'cancelled') === 'false'
                }
                onClick={() => {
                  handleChange('cancelled', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.currency === 'undefined' && (
          <FormGroup>
            <Label>Valuta</Label>
            <Select
              instanceId="select-currency"
              name="currency"
              value={_.get(resolvedQuery, 'currency', '')}
              onChange={handleChange}
              options={[
                { value: 'SEK', label: 'SEK' },
                { value: 'NOK', label: 'NOK' },
                { value: 'DKK', label: 'DKK' },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.customerSubUnit === 'undefined' && (
          <FormGroup>
            <Label>Centrala kunder</Label>
            <CustomerSubUnitSelect
              defaultOptions={false}
              instanceId="select-customerSubUnit"
              name="customerSubUnit"
              value={_.get(resolvedQuery, 'customerSubUnit')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.supplierCustomer === 'undefined' && (
          <FormGroup>
            <Label>Mina kunder</Label>
            <SupplierCustomerSelect
              defaultOptions={false}
              instanceId="select-supplierCustomer"
              name="supplierCustomer"
              value={_.get(resolvedQuery, 'supplierCustomer')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.deliveryName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryAddress === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryAddress2 === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryCity === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryZipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryCounty === 'undefined' && (
          <FormGroup>
            <Label>Län</Label>
            <Select
              type="string"
              instanceId="select-deliveryCounty"
              name="deliveryCounty"
              value={_.get(resolvedQuery, 'deliveryCounty')}
              onChange={handleChange}
              options={[
                { label: 'Västra Götaland', value: 'SE-O' },
                { label: 'Halland', value: 'SE-N' },
                { label: 'Skåne', value: 'SE-M' },
                { label: 'Blekinge', value: 'SE-K' },
                { label: 'Gotland', value: 'SE-I' },
                { label: 'Kalmar', value: 'SE-H' },
                { label: 'Kronoberg', value: 'SE-G' },
                { label: 'Jönköping', value: 'SE-F' },
                { label: 'Östergötland', value: 'SE-E' },
                { label: 'Södermanland', value: 'SE-D' },
                { label: 'Uppsala', value: 'SE-C' },
                { label: 'Jämtland', value: 'SE-Z' },
                { label: 'Västernorrland', value: 'SE-Y' },
                { label: 'Gävleborg', value: 'SE-X' },
                { label: 'Dalarna', value: 'SE-W' },
                { label: 'Norrbotten', value: 'SE-BD' },
                { label: 'Örebro', value: 'SE-T' },
                { label: 'Värmland', value: 'SE-S' },
                { label: 'Västmanland', value: 'SE-U' },
                { label: 'Västerbotten', value: 'SE-AC' },
                { label: 'Stockholm', value: 'SE-AB' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.deliveryCountry === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryInformation === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryDate === 'undefined' && (
          <FormGroup>
            <Label>Leverantörens leveransdatum</Label>
            <DateRangePicker
              name="deliveryDate"
              value={_.get(resolvedQuery, 'deliveryDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.requestedDeliveryDate === 'undefined' && (
          <FormGroup>
            <Label>Önskat leveransdatum</Label>
            <DateRangePicker
              name="requestedDeliveryDate"
              value={_.get(resolvedQuery, 'requestedDeliveryDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.invoiceDate === 'undefined' && (
          <FormGroup>
            <Label>Fakturadatum</Label>
            <DateRangePicker
              name="invoiceDate"
              value={_.get(resolvedQuery, 'invoiceDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.flaivyPaysForHandling === 'undefined' && (
          <FormGroup>
            <Label>Flaivy betalar för hantering</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'flaivyPaysForHandling') === undefined
                }
                onClick={() => {
                  handleChange('flaivyPaysForHandling', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'flaivyPaysForHandling') === true ||
                  _.get(resolvedQuery, 'flaivyPaysForHandling') === 'true'
                }
                onClick={() => {
                  handleChange('flaivyPaysForHandling', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'flaivyPaysForHandling') === false ||
                  _.get(resolvedQuery, 'flaivyPaysForHandling') === 'false'
                }
                onClick={() => {
                  handleChange('flaivyPaysForHandling', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.notCompleted === 'undefined' && (
          <FormGroup>
            <Label>Ej klar</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'notCompleted') === undefined}
                onClick={() => {
                  handleChange('notCompleted', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'notCompleted') === true ||
                  _.get(resolvedQuery, 'notCompleted') === 'true'
                }
                onClick={() => {
                  handleChange('notCompleted', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'notCompleted') === false ||
                  _.get(resolvedQuery, 'notCompleted') === 'false'
                }
                onClick={() => {
                  handleChange('notCompleted', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.orderDate === 'undefined' && (
          <FormGroup>
            <Label>Orderdatum</Label>
            <DateRangePicker
              name="orderDate"
              value={_.get(resolvedQuery, 'orderDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.orderType === 'undefined' && (
          <FormGroup>
            <Label>Ordertyp</Label>
            <Select
              type="string"
              instanceId="select-orderType"
              name="orderType"
              value={_.get(resolvedQuery, 'orderType')}
              onChange={handleChange}
              options={[
                { label: 'Order', value: 'Order' },
                { label: 'Restorder', value: 'Backorder' },
                { label: 'Returorder', value: 'ReturnOrder' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.termsOfPayment === 'undefined' && (
          <FormGroup>
            <Label>Betalningsvillkor</Label>
            <Select
              type="string"
              instanceId="select-termsOfPayment"
              name="termsOfPayment"
              value={_.get(resolvedQuery, 'termsOfPayment')}
              onChange={handleChange}
              options={[
                { label: '0 dagar', value: '0' },
                { label: '10 dagar', value: '10' },
                { label: '15 dagar', value: '15' },
                { label: '20 dagar', value: '20' },
                { label: '30 dagar', value: '30' },
                { label: '35 dagar', value: '35' },
                { label: '60 dagar', value: '60' },
                { label: '70 dagar', value: '70' },
                { label: 'Autogiro', value: 'A' },
                { label: 'Kontant', value: 'K' },
                { label: 'Postförskott', value: 'PF' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.organisationNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.remarks === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.yourReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.yourOrderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.trackingCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.transportProvider === 'undefined' && (
          <FormGroup>
            <Label>Transportör</Label>
            <Select
              type="string"
              instanceId="select-transportProvider"
              name="transportProvider"
              value={_.get(resolvedQuery, 'transportProvider')}
              onChange={handleChange}
              options={[
                { label: 'PostNord', value: 'POSTNORD' },
                { label: 'Budcompaniett', value: 'BUDCOMPANIETT' },
                { label: 'DLP', value: 'DLP' },
                { label: 'DSV', value: 'DSV' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.phone === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.ourReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.email === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.invoiceReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.advanceInvoiceReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.orderReference === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryPalletTypes === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryPalletType === 'undefined' && (
          <FormGroup>
            <Label>Order packad på</Label>
            <Select
              type="string"
              instanceId="select-deliveryPalletType"
              name="deliveryPalletType"
              value={_.get(resolvedQuery, 'deliveryPalletType')}
              onChange={handleChange}
              options={[
                { label: 'SRS halvpall', value: 'SRS_EUR6' },
                { label: 'SRS helpall', value: 'SRS_EPAL' },
                { label: 'Helpall', value: 'EPAL' },
                { label: 'Kvartspall', value: 'QUARTER_PALLET' },
                { label: 'Halvpall', value: 'EUR6' },
                { label: 'Annat (paket, styck kolli)', value: 'OTHER' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.ARCNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.needSpecialHandling === 'undefined' && (
          <FormGroup>
            <Label>Behöver specialhantering kring order</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'needSpecialHandling') === undefined
                }
                onClick={() => {
                  handleChange('needSpecialHandling', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'needSpecialHandling') === true ||
                  _.get(resolvedQuery, 'needSpecialHandling') === 'true'
                }
                onClick={() => {
                  handleChange('needSpecialHandling', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'needSpecialHandling') === false ||
                  _.get(resolvedQuery, 'needSpecialHandling') === 'false'
                }
                onClick={() => {
                  handleChange('needSpecialHandling', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.supplierComment === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.isMergedOrder === 'undefined' && (
          <FormGroup>
            <Label>Sammanslagen order</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isMergedOrder') === undefined}
                onClick={() => {
                  handleChange('isMergedOrder', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isMergedOrder') === true ||
                  _.get(resolvedQuery, 'isMergedOrder') === 'true'
                }
                onClick={() => {
                  handleChange('isMergedOrder', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isMergedOrder') === false ||
                  _.get(resolvedQuery, 'isMergedOrder') === 'false'
                }
                onClick={() => {
                  handleChange('isMergedOrder', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.orderFlowType === 'undefined' && (
          <FormGroup>
            <Label>Typ av orderflöde</Label>
            <Select
              type="string"
              instanceId="select-orderFlowType"
              name="orderFlowType"
              value={_.get(resolvedQuery, 'orderFlowType')}
              onChange={handleChange}
              options={[
                { label: 'standard', value: 'standard' },
                { label: 'email', value: 'email' },
                { label: 'freshx', value: 'freshx' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.labels === 'undefined' && (
          <FormGroup>
            <Label>Etiketter</Label>
            <LabelInput
              instanceId="select-labels"
              name="labels"
              value={_.get(resolvedQuery, 'labels')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.cartId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.shouldHaveVAT === 'undefined' && (
          <FormGroup>
            <Label>Ska ordern ha moms</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'shouldHaveVAT') === undefined}
                onClick={() => {
                  handleChange('shouldHaveVAT', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'shouldHaveVAT') === true ||
                  _.get(resolvedQuery, 'shouldHaveVAT') === 'true'
                }
                onClick={() => {
                  handleChange('shouldHaveVAT', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'shouldHaveVAT') === false ||
                  _.get(resolvedQuery, 'shouldHaveVAT') === 'false'
                }
                onClick={() => {
                  handleChange('shouldHaveVAT', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.hasExternalReference === 'undefined' && (
          <FormGroup>
            <Label>Har referens till annat system</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasExternalReference') === undefined
                }
                onClick={() => {
                  handleChange('hasExternalReference', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasExternalReference') === true ||
                  _.get(resolvedQuery, 'hasExternalReference') === 'true'
                }
                onClick={() => {
                  handleChange('hasExternalReference', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasExternalReference') === false ||
                  _.get(resolvedQuery, 'hasExternalReference') === 'false'
                }
                onClick={() => {
                  handleChange('hasExternalReference', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.totalExclVATnRecycle === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.requiresSupplierCustomer === 'undefined' && (
          <FormGroup>
            <Label>Ska ha leverantörskund</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresSupplierCustomer') === undefined
                }
                onClick={() => {
                  handleChange('requiresSupplierCustomer', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresSupplierCustomer') === true ||
                  _.get(resolvedQuery, 'requiresSupplierCustomer') === 'true'
                }
                onClick={() => {
                  handleChange('requiresSupplierCustomer', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresSupplierCustomer') === false ||
                  _.get(resolvedQuery, 'requiresSupplierCustomer') === 'false'
                }
                onClick={() => {
                  handleChange('requiresSupplierCustomer', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.orderRows === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

OrderFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

OrderFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function OrderFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <OrderFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

OrderFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

OrderFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { OrderFilterPanel, OrderFilterPanelModal };
